__turbopack_context__.v({
  "popup": "HotspotPopover-module-scss-module___vYjJW__popup",
  "positioner": "HotspotPopover-module-scss-module___vYjJW__positioner",
});
